import { CellProps } from 'react-table';
import { useMemo } from 'react';

import { IManifestationPreviewVM } from '../ManifestationPreviewVM';
import DateField from 'src/components/common/Table/DateField';
import TextField from 'src/components/common/Table/TextField';
import useTableActions, {
  HandleClick,
  TableActionParams,
} from '../../../helpers/table/use-table-actions';
import AuthorField from '../../../helpers/table/AuthorField';
import StatusField from '../../../helpers/table/StatusField';

interface useTableColumnProps extends TableActionParams<IManifestationPreviewVM> {
  handleDeleteClick: HandleClick<IManifestationPreviewVM>;
}

export const useTableColumn = ({
  handleDeleteClick,
  handleEditClick,
  handleHistoryClick,
}: useTableColumnProps): any[] => {
  const actionsColumn = useTableActions<IManifestationPreviewVM>({
    handleDeleteClick,
    handleEditClick,
    handleHistoryClick,
  });

  return useMemo(
    () => [
      {
        Header: 'Date de déclaration',
        id: 'creationDate',
        accessor: 'creationDate',
        sortType: 'datetime',
        sortable: true,
        width: '15%',
        Cell: (props: CellProps<IManifestationPreviewVM>) => {
          const date = props.cell.value;

          return <DateField date={date} />;
        },
      },
      {
        Header: 'Manifestation déclarée par le patient',
        accessor: 'label',
        width: '50%',
        Cell: (props: CellProps<IManifestationPreviewVM>) => {
          const label = props.cell.value;

          return <TextField label={label} variant={'h5'} />;
        },
      },
      {
        Header: 'Modification',
        accessor: 'answerType',
        width: '15%',
        Cell: (props: CellProps<IManifestationPreviewVM>) => {
          const answerType = props.cell.value;

          return <AuthorField value={answerType} />;
        },
      },
      {
        Header: 'Statut',
        accessor: 'status',
        width: '15%',
        sortable: true,
        Cell: (props: CellProps<IManifestationPreviewVM>) => {
          const status = props.cell.value;

          return <StatusField status={status} />;
        },
      },
      actionsColumn,
    ],
    [actionsColumn],
  );
};
